// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"GtD+aAt2MsQDFv1QtBuc3A==","title":"spAjBbgfkZ3-MzR66CeOKw==","subTitle":"_67QjMmOBMtZjq+Iqinwosg==","description":"LbORdQ7aBUF1CS6gNLNQww=="};